const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function reportCommentModal() {
  const modal = document.getElementById("reportCommentModal");
  const form = document.getElementById("report-comment-form");
  const successBox = modal ? modal.querySelector(".report-success") : null;
  const otherHint = modal ? modal.querySelector(".report-other-hint") : null;
  const otherCheckbox = document.getElementById("reason-other-checkbox");
  const steps = modal ? Array.from(modal.querySelectorAll(".report-step")) : [];
  let currentStep = 1;
  let lastTriggerBtn = null;

  if (!modal || !form || steps.length === 0) return;

  function fieldError(id, msg) {
    const el = document.getElementById(id);
    if (!el) return;
    el.textContent = msg;
    el.style.display = msg ? "" : "none";
  }

  function clearFieldErrors() {
    modal.querySelectorAll(".report-field-error").forEach(function (el) {
      el.textContent = "";
      el.style.display = "none";
    });
  }

  function getCsrfField() {
    return document.getElementById("report-csrf-field");
  }

  function getCsrfHash() {
    const field = getCsrfField();
    if (field && field.value) {
      return field.value;
    }

    return typeof window.sec_token === "string" ? window.sec_token : "";
  }

  function updateCsrfHash(hash) {
    if (!hash) {
      return;
    }

    const field = getCsrfField();
    if (field) {
      field.value = hash;
    }

    window.sec_token = hash;
  }

  function ensureReportRecaptcha() {
    const container = document.getElementById("report-recaptcha");
    const submitBtn = document.getElementById("report-submit-btn");
    if (!container || typeof grecaptcha === "undefined") {
      return;
    }

    const sitekey = container.dataset.sitekey;
    if (!sitekey) {
      return;
    }

    if (
      window.reportRecaptchaWidgetId !== undefined &&
      window.reportRecaptchaWidgetId !== null
    ) {
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    if (submitBtn) submitBtn.disabled = true;

    grecaptcha.ready(function () {
      if (
        window.reportRecaptchaWidgetId !== undefined &&
        window.reportRecaptchaWidgetId !== null
      ) {
        if (submitBtn) submitBtn.disabled = false;
        return;
      }

      window.reportRecaptchaWidgetId = grecaptcha.render("report-recaptcha", {
        sitekey: sitekey,
        theme: "light",
        "expired-callback": function () {
          if (submitBtn) submitBtn.disabled = false;
        },
      });
      if (submitBtn) submitBtn.disabled = false;
    });
  }

  function resetReportRecaptcha() {
    if (
      window.reportRecaptchaWidgetId !== undefined &&
      window.reportRecaptchaWidgetId !== null &&
      typeof grecaptcha !== "undefined"
    ) {
      grecaptcha.reset(window.reportRecaptchaWidgetId);
    }
  }

  function showStep(n) {
    steps.forEach(function (s) {
      s.style.display = parseInt(s.dataset.step, 10) === n ? "" : "none";
    });
    clearFieldErrors();
    currentStep = n;

    const privacyNotice = modal.querySelector(".report-privacy-notice");
    const privacyDivider = modal.querySelector(".report-privacy-divider");
    if (privacyNotice) {
      privacyNotice.style.display = n === 1 ? "" : "none";
    }
    if (privacyDivider) {
      privacyDivider.style.display = n === 1 ? "" : "none";
    }

    const modalBody = modal.querySelector(".modal-body");
    if (modalBody) {
      modalBody.scrollTop = 0;
    }

    if (n === 3) {
      ensureReportRecaptcha();
    }

    const stepEl = steps.find(function (s) {
      return parseInt(s.dataset.step, 10) === n;
    });
    if (stepEl) {
      const first = stepEl.querySelector(
        'input:not([type="hidden"]), select, textarea, button',
      );
      if (first) first.focus();
    }
  }

  function clearCurrentStep() {
    const stepEl = steps.find(function (s) {
      return parseInt(s.dataset.step, 10) === currentStep;
    });
    if (!stepEl) return;
    stepEl
      .querySelectorAll("input:not([type=hidden]), textarea, select")
      .forEach(function (el) {
        if (el.type === "checkbox" || el.type === "radio") {
          el.checked = false;
        } else {
          el.value = "";
        }
      });
    clearFieldErrors();
    if (otherHint) otherHint.style.display = "none";
  }

  function validateStep(n) {
    clearFieldErrors();
    let valid = true;

    if (n === 1) {
      const email = form.querySelector('[name="reporter_email"]');
      const affected = form.querySelector('[name="directly_affected"]:checked');
      if (!email.value.trim() || !validEmailRegex.test(email.value.trim())) {
        fieldError(
          "error-reporter-email",
          "Please enter a valid email address.",
        );
        email.focus();
        valid = false;
      }
      if (!affected) {
        fieldError(
          "error-directly-affected",
          "Please indicate whether you are directly affected.",
        );
        if (valid) form.querySelector('[name="directly_affected"]').focus();
        valid = false;
      }
    }

    if (n === 2) {
      const type = form.querySelector('[name="type"]:checked');
      const reasons = form.querySelectorAll('[name="reason[]"]:checked');
      const description = form.querySelector('[name="description"]');
      if (!type) {
        fieldError("error-type", "Please select what you are reporting.");
        valid = false;
      }
      if (reasons.length === 0) {
        fieldError("error-reason", "Please select at least one reason.");
        if (valid) form.querySelector('[name="reason[]"]').focus();
        valid = false;
      }
      if (!description.value.trim()) {
        fieldError("error-description", "Please provide a description.");
        if (valid) description.focus();
        valid = false;
      }
    }

    return valid;
  }

  function resetWizard() {
    form.reset();
    clearFieldErrors();
    if (successBox) successBox.style.display = "none";
    form.style.display = "";
    if (otherHint) otherHint.style.display = "none";
    const modalBody = modal.querySelector(".modal-body");
    if (modalBody) modalBody.classList.remove("report-show-success");
    showStep(1);
  }

  function handleReportResponse(status, data) {
    if (data && data.csrf_hash) {
      updateCsrfHash(data.csrf_hash);
    }

    if (status === 200 && data.success) {
      const modalBody = modal.querySelector(".modal-body");
      const privacyNotice = modal.querySelector(".report-privacy-notice");
      const privacyDivider = modal.querySelector(".report-privacy-divider");

      form.style.display = "none";
      if (privacyNotice) privacyNotice.style.display = "none";
      if (privacyDivider) privacyDivider.style.display = "none";
      if (modalBody) {
        modalBody.classList.add("report-show-success");
        modalBody.scrollTop = 0;
      }
      if (successBox) successBox.style.display = "";
      setTimeout(function () {
        $(modal).modal("hide");
      }, 5000);
      return;
    }

    if (status === 403) {
      showStep(3);
      fieldError(
        "error-recaptcha",
        "Your session expired. Please refresh the page and try again.",
      );
      return;
    }

    if (status === 422 && data.errors) {
      if (data.errors.description) {
        showStep(2);
        fieldError("error-description", data.errors.description);
      }
      if (data.errors["g-recaptcha-response"]) {
        showStep(3);
        fieldError("error-recaptcha", data.errors["g-recaptcha-response"]);
        resetReportRecaptcha();
      }
      Object.keys(data.errors).forEach(function (field) {
        if (field === "description" || field === "g-recaptcha-response") {
          return;
        }
        const errorId = "error-" + field.replace(/[[\]_]/g, "-");
        fieldError(errorId, data.errors[field]);
      });
      return;
    }

    showStep(3);
    fieldError(
      "error-recaptcha",
      data.message || "Something went wrong. Please try again.",
    );
  }

  // Open modal on report button click
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".report-comment-btn");
    if (!btn) return;
    e.stopPropagation();

    document.getElementById("report-comment-id").value = btn.dataset.commentId;
    document.getElementById("report-phone-number").value =
      btn.dataset.phoneNumber;

    resetWizard();
    lastTriggerBtn = btn;
    $(modal).modal("show");
  });

  // Reset wizard and return focus on modal close
  $(modal).on("hidden.bs.modal", function () {
    resetWizard();
    resetReportRecaptcha();
    if (lastTriggerBtn) lastTriggerBtn.focus();
  });

  // Next buttons
  modal.addEventListener("click", function (e) {
    if (!e.target.classList.contains("report-next-btn")) return;
    if (validateStep(currentStep)) showStep(currentStep + 1);
  });

  // Back buttons
  modal.addEventListener("click", function (e) {
    if (!e.target.classList.contains("report-back-btn")) return;
    clearFieldErrors();
    showStep(currentStep - 1);
  });

  // Clear buttons — only clear the current step's fields
  modal.addEventListener("click", function (e) {
    if (!e.target.classList.contains("report-clear-btn")) return;
    clearCurrentStep();
  });

  // Show/hide "Other" hint
  if (otherCheckbox && otherHint) {
    otherCheckbox.addEventListener("change", function () {
      otherHint.style.display = this.checked ? "" : "none";
    });
  }

  // Submit on step 3
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    clearFieldErrors();
    const declaration = document.getElementById("report-declaration");
    let valid = true;

    if (!declaration.checked) {
      fieldError(
        "error-declaration",
        "You must confirm the declaration before submitting.",
      );
      if (valid) declaration.focus();
      valid = false;
    }

    if (
      window.reportRecaptchaWidgetId === undefined ||
      window.reportRecaptchaWidgetId === null
    ) {
      fieldError(
        "error-recaptcha",
        "Verification is still loading. Please wait a moment and try again.",
      );
      valid = false;
    } else if (grecaptcha.getResponse(window.reportRecaptchaWidgetId) === "") {
      fieldError("error-recaptcha", "Please check the recaptcha box.");
      valid = false;
    }

    if (!valid) return;

    if (successBox) successBox.style.display = "none";

    const submitBtn = document.getElementById("report-submit-btn");
    submitBtn.disabled = true;

    const csrfHash = getCsrfHash();
    const recaptchaToken = grecaptcha.getResponse(
      window.reportRecaptchaWidgetId,
    );
    const formData = new FormData();
    const csrfField = getCsrfField();

    if (csrfField) {
      formData.append(csrfField.name, csrfHash);
    }

    form.querySelectorAll("input, textarea, select").forEach(function (el) {
      if (!el.name || el === csrfField) {
        return;
      }

      if (el.type === "checkbox") {
        if (el.checked) {
          formData.append(el.name, el.value);
        }
        return;
      }

      if (el.type === "radio") {
        if (el.checked) {
          formData.append(el.name, el.value);
        }
        return;
      }

      if (el.type === "file") {
        return;
      }

      formData.append(el.name, el.value);
    });

    formData.append("g-recaptcha-response", recaptchaToken);

    fetch("/comment/report/", {
      method: "POST",
      body: formData,
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": csrfHash,
      },
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { status: res.status, data: data };
          });
      })
      .then(function ({ status, data }) {
        handleReportResponse(status, data);
      })
      .catch(function () {
        handleReportResponse(0, {
          message: "Something went wrong. Please try again.",
        });
      })
      .finally(function () {
        submitBtn.disabled = false;
      });
  });
}
